__turbopack_context__.v({
  "image": "YcRutq_image",
  "wordmark": "YcRutq_wordmark",
});
